import { ButtonHTMLAttributes, ReactNode, forwardRef } from 'react';

import { ButtonIconStyled } from './ButtonIcon.styled';

type ButtonIconPropsT = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: ReactNode;
  color?: 'white' | 'darkBlue';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'contained' | 'outline' | 'transparent';
  disabled?: boolean;
};

const ButtonIcon = forwardRef<HTMLButtonElement, ButtonIconPropsT>(
  ({ icon, ...restProps }, ref) => (
    <ButtonIconStyled ref={ref} {...restProps}>
      {icon}
    </ButtonIconStyled>
  )
);

export default ButtonIcon;
